module.exports = "/images/everestPath6.png?3dee11573d2527fc9f0f63a637e6d332";